import { memo } from "react";
import Box, { type BoxProps } from "@mui/material/Box";
import { CustomAvatar, type CustomAvatarProps } from "lib/custom-avatar";

export type AccountProps = BoxProps & {
    readonly CustomAvatarProps: CustomAvatarProps;
};

const Account = ({ children, CustomAvatarProps, ...props }: AccountProps) => (
    <Box
        sx={{
            display: 'grid',
            gridTemplateColumns: 'min-content auto',
            gap: 3,
            alignItems: 'center',
            ...props.sx
        }}
    >
        <CustomAvatar
            {...CustomAvatarProps}
        />
        <Box
            sx={{
                fontFamily: 'var(--primary-font)'
            }}
        >
            {children}
        </Box>
    </Box>
);

export default memo(Account);
